/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Precision_DescInputs */

const en_cad_features_precision_desc = /** @type {(inputs: Cad_Features_Precision_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object snaps, polar tracking, ortho and grid snap, plus direct distance entry. Right-click, Enter or Space repeats the last command.`)
};

/**
* | output |
* | --- |
* | "Object snaps, polar tracking, ortho and grid snap, plus direct distance entry. Right-click, Enter or Space repeats the last command." |
*
* @param {Cad_Features_Precision_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_precision_desc = /** @type {((inputs?: Cad_Features_Precision_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Precision_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_precision_desc(inputs)
});
export { cad_features_precision_desc as "cad.features.precision_desc" }